let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b5c4G")).then(() => parcelRequire('iHQhD'));